import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  border: 1px solid #46859469;
  padding: 12px;
  box-sizing: border-box;
  flex: 0 0 80%;
`;
